// src/QRCodeModal.js - VERSIONE FINALE CON EDITOR GRAFICO SEMPLIFICATO E LOGO

import React, { useState, useEffect, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react'; 
import moment from 'moment';
import { jsPDF } from 'jspdf';
// Assumiamo che jsPDF sia disponibile (installato con --legacy-peer-deps)
// Assumiamo che v4 sia disponibile (installato con --legacy-peer-deps)

// Funzione per il download PNG (usa il canvas ref)
const downloadQRCodeAsPNG = (canvasRef, fileName) => { 
    const canvas = canvasRef.current.querySelector('canvas');
    if (canvas) {
        const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = `${fileName}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
};

// Funzione per il download PDF (usa il canvas ref e il titolo custom)
const downloadQRCodeAsPDF = (canvasRef, qrId, title) => {
  

    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgData = canvasRef.current.querySelector('canvas').toDataURL('image/png');
    
    const qrSize = 70; // mm
    const margin = 20; // mm
    const centerX = (pdf.internal.pageSize.getWidth() - qrSize) / 2;
    
    // 1. Aggiungi il Titolo (Custom)
    pdf.setFontSize(18);
    pdf.text(title || "QR Code Timbratura Presenze", pdf.internal.pageSize.getWidth() / 2, margin, { align: 'center' });
    
    // 2. Aggiungi il QR Code
    pdf.addImage(imgData, 'PNG', centerX, margin + 10, qrSize, qrSize);
    
    // 3. Aggiungi le istruzioni
    pdf.setFontSize(12);
    pdf.text(`Codice ID: ${qrId}`, pdf.internal.pageSize.getWidth() / 2, margin + 10 + qrSize + 10, { align: 'center' });
    pdf.setFontSize(10);
    //pdf.text("Affiggere questo codice all'ingresso del centro.", pdf.internal.pageSize.getWidth() / 2, margin + 10 + qrSize + 20, { align: 'center' });
    
    pdf.save(`QR_Timbratura.pdf`);
};

export function QRCodeModal({ qrId, onClose }) {
    const content = qrId;
    
    const [size, setSize] = useState(300);
    const [fgColor, setFgColor] = useState('#000000');
    const [bgColor, setBgColor] = useState('#ffffff');
    const [title, setTitle] = useState('Scansione e Timbratura'); // Titolo di default richiesto
    const [logoUrl, setLogoUrl] = useState(null); 
    const canvasRef = useRef(null);

    // Gestione Caricamento Logo (solo lato client) 
    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const newUrl = URL.createObjectURL(file);
            setLogoUrl(newUrl);
            e.target.value = null; 
        }
    };
    
    // Configurazione Immagine Centrale
    const imageSettings = logoUrl ? {
        src: logoUrl,
        x: null, 
        y: null,
        height: size / 5, // 1/5 della dimensione QR
        width: size / 5,
        excavate: true, // Taglia un buco nel QR per il logo
    } : undefined;

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content modal-content-large" onMouseDown={e => e.stopPropagation()} style={{ maxWidth: '800px' }}>
                <h3>Genera e Stampa QR Code</h3>

                <div style={{ display: 'flex', gap: '30px', marginTop: '20px', flexDirection: 'row', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                    
                    {/* --- COLONNA 1: QR Code e Download --- */}
                    <div style={{ flex: 1, minWidth: '300px', textAlign: 'center' }}>
                         <div style={{marginBottom: '10px'}}>
                            <h4 style={{fontSize: '1.2rem', margin: '0'}}>{title || 'Anteprima QR'}</h4>
                         </div>
                        <div ref={canvasRef} style={{ border: '1px solid #ccc', padding: '10px', display: 'inline-block', borderRadius: '8px' }}>
                            {/* Generazione QR Code */}
                            {qrId ? (
                                <QRCodeCanvas
                                    value={content}
                                    size={size}
                                    level="H"
                                    bgColor={bgColor}
                                    fgColor={fgColor}
                                    imageSettings={imageSettings} 
                                />
                            ) : (
                                <p style={{ width: `${size}px`, height: `${size}px`, border: '1px dashed #aaa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    QR ID non generato.
                                </p>
                            )}
                        </div>

                        <p style={{ marginTop: '10px', fontSize: '0.8rem', color: '#6c757d' }}>
                            ID univoco: <strong>{qrId}</strong>
                        </p>
                        
                        <div style={{ marginTop: '20px', display: 'flex', gap: '10px', flexDirection: 'column' }}>
                            <button 
                                onClick={() => downloadQRCodeAsPDF(canvasRef, qrId, title)}
                                className="modal-button confirm-button"
                                disabled={!qrId}
                            >
                                Salva & Scarica PDF (Pronto Stampa)
                            </button>
                            <button 
                                onClick={() => downloadQRCodeAsPNG(canvasRef, `QR_Timbratura_${moment().format('YYYYMMDD')}`)} 
                                className="modal-button neutral-button"
                                disabled={!qrId}
                            >
                                Scarica Immagine PNG
                            </button>
                        </div>
                    </div>

                    {/* --- COLONNA 2: Personalizzazione --- */}
                    <div style={{ flex: 1, minWidth: '300px', textAlign: 'left' }}>
                        <h4>Personalizzazione Grafica</h4>
                        
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Titolo (nel Documento PDF)</label>
                            <input 
                                type="text" 
                                value={title} 
                                onChange={(e) => setTitle(e.target.value)} 
                                placeholder="Titolo del documento"
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Dimensione QR (px)</label>
                            <input 
                                type="number" 
                                value={size} 
                                onChange={(e) => setSize(Number(e.target.value))} 
                                min="100" 
                                max="800" 
                            />
                        </div>
                        
                        <div className="form-row">
                            <div className="form-group" style={{ flex: 1 }}>
                                <label>Colore QR</label>
                                <input type="color" value={fgColor} onChange={(e) => setFgColor(e.target.value)} style={{ width: '100%', height: '40px', padding: '2px' }} />
                            </div>
                            <div className="form-group" style={{ flex: 1 }}>
                                <label>Colore Sfondo</label>
                                <input type="color" value={bgColor} onChange={(e) => setBgColor(e.target.value)} style={{ width: '100%', height: '40px', padding: '2px' }} />
                            </div>
                        </div>
                        
                        {/* Sezione Logo */}
                        <h4 style={{marginTop: '30px'}}>Logo Centrale (Opzionale)</h4>
                         <div className="form-group">
                            <label>Carica Logo (PNG/JPG)</label>
                            <input 
                                type="file" 
                                accept="image/png, image/jpeg" 
                                onChange={handleLogoUpload}
                            />
                        </div>
                        {logoUrl && (
                            <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <img src={logoUrl} alt="Logo Anteprima" style={{ width: '50px', height: '50px', border: '1px solid #eee' }} />
                                <button 
                                    onClick={() => setLogoUrl(null)} 
                                    className="modal-button delete-button" 
                                    style={{padding: '5px 10px', fontSize: '0.8rem'}}
                                >
                                    Rimuovi Logo
                                </button>
                            </div>
                        )}
                        {/* Fine Sezione Logo */}

                        <p style={{ marginTop: '30px', fontSize: '0.85rem', color: '#dc3545' }}>
                            *Nota: Il logo può ridurre la leggibilità se troppo grande. Per il PDF, usa una dimensione QR ragionevole.
                        </p>
                    </div>

                </div>

                <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
                    <button onClick={onClose} className="modal-button cancel-button">Chiudi</button>
                </div>
            </div>
        </div>
    );
}